import React, {useEffect, useMemo, useState} from 'react';
import Table from 'apm/components/common/Table';



type PropsType = {
    user_data : SpiEmailDispatcherUsers[]
}
export default function TableUsers({user_data}: PropsType ) {
    useEffect(() => {
        
    }, []);

    return (
        <>
            {<Table
                columns={UsertableColumns}
                data={user_data}
                muiTableBodyProps={null}
                enableBottomToolbar={false}
                enableRowNumbers
            />}
        </>
    )
}

export type SpiEmailDispatcherUsers = {
    name: string
    email: string,
    designation: string,
}

const UsertableColumns: any  = [ 
    { accessorKey: 'name', header: 'Name', }, 
    { accessorKey: 'email', header: 'Email', }, 
    { accessorKey: 'designation', header: 'Designation' }
]
